<template>
    <div>
        <div class="info_config">
            <div class="p-2 mb-2 alert-success rounded" role="alert2" v-if="!app.conditionsAccepted">
                <p v-html="$t('s1_use_conditions')"></p>

                <button type="button" @click="acceptConditions()" class="btn btn-primary" data-dismiss="alert"
                    aria-label="Close">
                    {{ $t('s1_accept_conditions_button') }}
                </button>
            </div>
            <div v-if="!app.auth.isLogged && !app.udigitalAlertDismissed"
                class="alert alert-success alert-dismissible fade show" role="alert">
                {{ $t('s1_info_config_func_inicio_sesion') }}

                <button @click="app.dismissAlertUDigital()" type="button" class="close" data-dismiss="alert"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center" v-if="!app.isSpinnerVisible">
            <div v-for="configurator in app.configurators" :key="configurator.id">
                <configuratorComponent @configuratorSelected="configuratorSelected" :infoConfigurator="configurator">
                </configuratorComponent>
            </div>

            <!-- BUTTON MY CONFIGS -->
            <div class="mt-5 d-lg-none">
                <div>
                    <div class="row d-flex justify-content-start align-items-center" style="cursor:pointer;"
                        :style="isMobile ? 'width:350px' : 'width:450px'">
                        <!-- :src="infoConfigurator.image" -->
                        <img
                            :src="require('@/assets/images/mis-proyectos.png')"
                            class="ml-2 mr-3"
                            :style="isMobile ? 'max-height: 90px; width: auto;' : 'max-height: 175px; width: auto;'"
                        />
                        <!-- <img alt src="https://docs.unex.net/fie/images/ico_catalog.svg" class="ml-2 mr-3"
                            :style="isMobile ? 'max-height: 90px; width: auto;' : 'max-height: 175px; width: auto;'" /> -->
                        <div style="max-width:200px; color:black" class="mr-1 mt-3">
                            <p style="text-align: left; font-weight: bold;" @click="app.showMyConfigs()">
                                {{ $t('nav_titel_my_configs') }}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { app } from "../../application.js";
import attribute from "../../models/attribute.js";
import configuratorComponent from "./configurator.vue";

export default {
    name: "configuratorsComponent",
    data() {
        return {
            app: app,
        };
    },
    beforeMount() {
        this.app.loadConfigurators();

    },
    computed: {
        isMobile: function () {
            let a = window.innerWidth < 600;
            return a;
        }
    },
    components: { configuratorComponent },
    methods: {
        async configuratorSelected(configurator) {
            this.app.currentConfiguration.configurator = configurator;

            let result = await this.app.navigateToNextStage();

            if (result == false) {
                this.app.currentConfiguration.configurator = null;
            } else {
                // Analytics
                this.app.trackParameterSelection("configurator", configurator.id);
            }
        },
        async acceptConditions() {
            await this.app.acceptConditions();
        }
    }
};
</script>

<style lang="scss">
.info_config {
    position: relative;
    max-width: 700px;
    margin: auto;
    font-size: 15px;
}

.textLinkMyConfigs {
    color: #585858 !important;
}

.alert a {
    text-decoration: underline !important;
}
</style>
